import { ListItemText } from "@mui/material";
import { StyledRgrl } from "../../../../styled/Prevencion";

const DatosEstablecimientoPresentacion = ({ data }) => {

  return (
    <StyledRgrl.List>
      <StyledRgrl.ListItem key="nombre">
        <StyledRgrl.Label>
          Nombre Establecimiento
        </StyledRgrl.Label>
        <ListItemText
          secondary={
            data?.nombre ? data.nombre.split("-")[0] : "Sin Información"
          }
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="domicilio">
        <StyledRgrl.Label>Domicilio</StyledRgrl.Label>
        <ListItemText
          secondary={data?.domicilio ? data?.domicilio : "Sin Información"}
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="matrizUnica">
        <StyledRgrl.Label>Matriz Única</StyledRgrl.Label>
        <ListItemText
          secondary={data?.matrizUnica ? data.matrizUnica : "Sin Información"}
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="codigoIntercambio">
        <StyledRgrl.Label>Cod. Intercambio</StyledRgrl.Label>
        <ListItemText
          secondary={
            data?.codigoIntercambio
              ? data?.codigoIntercambio
              : "Sin Información"
          }
        />
      </StyledRgrl.ListItem>
      <StyledRgrl.ListItem key="actividad">
        <StyledRgrl.Label>
          Actividad Establecimiento
        </StyledRgrl.Label>
        <ListItemText
          secondary={data?.actividad ? data.actividad : "Sin Información"}
        />
      </StyledRgrl.ListItem>
    </StyledRgrl.List>
  );
};

export default DatosEstablecimientoPresentacion;
